// extracted by mini-css-extract-plugin
module.exports = {"root":"FaqList-module--root--1k8RF","faqList":"FaqList-module--faqList--1FCZT"};